import { BlocksIconShow } from 'blocks-nextjs/blocks-web-components/components/icon/icons/show';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconShow = createComponent({ react: React, tagName: 'cat-icon-show', elementClass: BlocksIconShow });
